import type { UserSummary } from '@novachat/shared';
import { useQuery } from '@tanstack/react-query';
import { client } from './client';

const nobody: UserSummary[] = [];

/** Everyone who can use NovaChat (names for mentions, typing, pickers); shared and cached. */
export function useDirectory(): UserSummary[] {
  return useQuery({ queryKey: ['users'], queryFn: () => client.api.users(), staleTime: 5 * 60_000 }).data ?? nobody;
}
